import { Injectable } from "@angular/core";
import { Company } from "../model/company.model";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { environment } from "@env/environment";

@Injectable({
  providedIn: "root",
})
export class CompanyService {
  api_url = environment.baseIP + environment.apiPrefix;
  access_token: any;

  constructor(
    private httpClient: HttpClient,
    private _cookieService: CookieService
  ) {
    this.access_token = this._cookieService.get("access_token");
  }

  selectedCompany: Company | any;

  setSelectedCompany(company: Company) {
    this.selectedCompany = company;
  }

  getSelectedCompany(): Company | any {
    return this.selectedCompany;
  }

  private getAuthHeaders() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.access_token,
      }),
    };
  }

  getCompanyList(body: any): Observable<any> {
    return this.httpClient.post(
      `${this.api_url}company/list`,
      body,
      this.getAuthHeaders()
    );
  }

  deleteCompanyLists(body): Observable<any> {
    return this.httpClient.post(
      `${this.api_url}company/remove`,
      body,
      this.getAuthHeaders()
    );
  }

  addCompanyLists(body): Observable<any> {
    return this.httpClient.post(
      `${this.api_url}company/create`,
      body,
      this.getAuthHeaders()
    );
  }

  updateCompanyLists(body): Observable<any> {
    return this.httpClient.post(
      `${this.api_url}company/edit`,
      body,
      this.getAuthHeaders()
    );
  }

  companyListSearch(body): Observable<any> {
    return this.httpClient.post(
      `${this.api_url}company/list`,
      body,
      this.getAuthHeaders()
    );
  }

  getCompanyCallLogsService(body: any): Observable<any> {
    console.log("Fetching call logs with body:", body);
    return this.httpClient.post(
      `${this.api_url}activitylog/list`,
      body,
      this.getAuthHeaders()
    );
  }

  addEditCallLogService(body: any): Observable<any> {
    const endpoint = body.activity_log_id
      ? `${this.api_url}activitylog/edit`
      : `${this.api_url}activitylog/add`;

    console.log(`Saving/Editing call log to: ${endpoint}`, body);
    return this.httpClient.post(endpoint, body, this.getAuthHeaders());
  }

  deleteCallLogService(body: any): Observable<any> {
    console.log("Deleting call log with body:", body);
    return this.httpClient.post(
      `${this.api_url}activitylog/remove`,
      body,
      this.getAuthHeaders()
    );
  }

  addCallLogCompany(body): Observable<any> {
    console.log("add body:", body);

    return this.httpClient.post(
      `${this.api_url}activitylog/add`,
      body,
      this.getAuthHeaders()
    );
  }

  deleteCalllogCompany(body): Observable<any> {
    return this.httpClient.post(
      `${this.api_url}activitylog/remove`,
      body,
      this.getAuthHeaders()
    );
  }

  editCallLogDetails(body): Observable<any> {
    return this.httpClient.post(
      `${this.api_url}activitylog/edit`,
      body,
      this.getAuthHeaders()
    );
  }

  searchCallLogCompany(body): Observable<any> {
    console.log("add body:", body);

    return this.httpClient.post(
      `${this.api_url}activitylog/list`,
      body,
      this.getAuthHeaders()
    );
  }

  //upload csv
  uploadCSVService(formData: FormData) {
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: "Bearer " + this.access_token,
    });
    return this.httpClient.post(`${this.api_url}company/csv-upload`, formData, {
      headers,
    });
  }

  //export csv
  downloadLeadsCsv(payload: any) {
    const headers = new HttpHeaders({
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Bearer " + this.access_token,
    });
    // Convert payload to URL-encoded string

    const body = new URLSearchParams();
    for (const key in payload) {
      body.set(key, payload[key]);
    }

    console.log("body:", body.toString());
    return this.httpClient.post(
      `${this.api_url}company/csv-export`,
      body.toString(),
      {
        headers: headers,
        responseType: "blob",
      }
    );
  }

  getCountryDropdown(): Observable<any> {
    console.log("country list called====");
    console.log("authorization", this.access_token);
    return this.httpClient.post(
      `${this.api_url}company/country`,
      {},
      this.getAuthHeaders()
    );
  }
}
